// vendors
import styled from 'styled-components';

// lego
import { Form as LegoForm } from 'lego-dist';

/* color: ${({ theme }) => theme.colors.newKinedu}; */

export const Form = styled(LegoForm).attrs(() => ({
  className: 'SettingsTeacherProfileForm',
}))`
  flex-flow: row wrap;
  padding: 35px 35px;
  justify-content: space-between;
  margin-bottom: 200px;
  #assignedClassroomsFormFieldsTitle {
    margin-top: 40px;
    padding-top: 25px;
    border-top: 2px solid #dde4ea;
  }
  .legoSelecterOptionsContainer {
    height: 150px;
    overflow: auto;
  }
  .legoFormButtonContainer {
    width: 100%;
    justify-content: flex-end;
  }
  .legoFormFieldset {
    width: 100%;

    .legoFormFieldLabel {
      font-size: 16px;
      font-weight: bold;
      color: ${({ theme }) => theme.colors.darkGray};
    }

    .legoFormCounter {
      top: 5px;
    }

    .legoFormInput,
    .legoSelecterContainer,
    .legoInputDatepickerContainer {
      margin-top: 7px;

      &::focus {
        outline: 2px solid ${({ theme }) => theme.colors.primary};
      }
    }

    .legoInputDatepickerContainer .legoInputDatepickerBox {
      width: 136px;
      justify-content: center;
      .legoInputDatepickerDateText {
        padding: 0;
        font-weight: normal;
      }
    }

    .legoSelecterContainer {
      cursor: pointer;
      .legoSelecterOptionIndicator {
        top: initial;
        cursor: pointer;
      }
      .legoSelecterOptionItem {
        display: flex;
        align-items: center;
        .legoSelecterItemLabel {
          color: initial;
          cursor: pointer;
          background-color: initial;
        }
      }
    }
  }

  ${({ theme }: any) => theme.breakPoints.tablet} {
    .legoFormFieldset {
      width: 49%;
    }
  }
`;

export const FormTitle = styled.div.attrs(() => ({
  className: 'SettingsTeacherProfileFormTitle',
}))`
  width: 100%;
  font-size: 18px;
  padding-bottom: 25px;
  font-weight: bold;
  color: #4A4A4A;
`;
